export enum CustomerRoutes {
    Customer = ':id',
    CustomerList = ''
}
